import { c as _c } from "react/compiler-runtime";
import { IconTextLayout } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal/event/read/header/icon-text-layout";
import Icon from "@/components/icon";
import { EventRead } from "@/TS/Interfaces/global_interfaces";
interface EventReadAddressProps {
  event: EventRead;
}
export const EventReadAddress: React.FC<EventReadAddressProps> = t0 => {
  const $ = _c(3);
  const {
    event
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon size={18} icon="localisation" className="mt-1" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = event.postalAddress?.place;
  let t3;
  if ($[1] !== t2) {
    t3 = <IconTextLayout>{t1}<div className="flex flex-col"><p className="font-bold">{t2}</p></div></IconTextLayout>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};